import script from "./loginComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./loginComponent.vue?vue&type=script&setup=true&lang=js"

import "./loginComponent.vue?vue&type=style&index=0&id=7e475469&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e475469"]])

export default __exports__